export default __webpack_public_path__ + "static/media/home-consulting-provide-solution.38127f26.jpg";